module.exports = __webpack_public_path__ + "static/media/ach-verification-success.89115bea.svg";